// The international phone field (intl-tel-input), for the GO4LEARN pages.
//
// GO4SCHOOL gets this controller from `application.js`. GO4LEARN pages load their own
// bundles (`learn`, `learn_site`), and intl-tel-input with its numbering rules weighs far
// more than the learner page budget (`vite/learn_budget_guard.mts`) allows — the guard
// weighs static AND dynamic imports of `learn*`. So the field ships as its own entry,
// requested only by the pages that render a phone input (`PhoneInputHelper#phone_input`).
import { Application } from "@hotwired/stimulus";
import IntlTelInputController from "../controllers/intl_tel_input_controller";

const application = Application.start();
application.register("intl-tel-input", IntlTelInputController);
